module.exports = __webpack_public_path__ + "static/media/bee-nests-flower-garden.b2ce4912.jpg";